import * as React from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { EAlertType, requestAuthentication } from 'shared/actions/authentication';
import { openChat } from 'shared/actions/chat';
import { CallUnderDescriptionBanner } from 'shared/components/CallUnderDescriptionBanner';
import { CardSectionNew } from 'shared/components/CardSectionNew';
import { HintQuestion, HintQuestions } from 'shared/components/HintQuestions';
import { CallToAuthor } from 'shared/components/HintQuestions/CallToAuthor';
import { useIsElectronicTradingOffer } from 'shared/hooks/useIsElectronicTradingOffer';
import { IChatHintSchema } from 'shared/repositories/chats/entities/chat_hint/ChatHintSchema';
import { selectIsOfferPublished, selectOffer, selectUser } from 'shared/selectors';
import { offerChatSelector } from 'shared/selectors/offerChat';

import { PhonesContainer } from './parts';
import { trackHintQuestionClick } from './tracking';

export const HintQuestionsContainer: React.FC = () => {
  const dispatch = useDispatch();
  const { isChatsEnabled, hintQuestions } = useSelector(offerChatSelector);
  const offer = useSelector(selectOffer);
  const user = useSelector(selectUser);
  const isOfferPublished = useSelector(selectIsOfferPublished);
  const isElectronicTradingOffer = useIsElectronicTradingOffer();

  const onClick = React.useCallback(
    (text: string) => {
      const { analyticsKey, messageText } = hintQuestions.find(
        ({ buttonText }) => buttonText === text,
      ) as IChatHintSchema;

      if (!user || !user.isAuthenticated) {
        dispatch(
          requestAuthentication({
            onSuccess: () => {
              trackHintQuestionClick(offer, analyticsKey);

              return openChat({ defaultMessage: messageText });
            },
            alert: EAlertType.Chats,
          }),
        );

        return;
      }

      dispatch(openChat({ defaultMessage: messageText }));
      trackHintQuestionClick(offer, analyticsKey);
    },
    [hintQuestions, offer, dispatch, user],
  );

  if (
    isElectronicTradingOffer ||
    !isOfferPublished ||
    !isChatsEnabled ||
    user?.cianUserId === offer.cianUserId ||
    !hintQuestions.length
  ) {
    return null;
  }

  return (
    <CardSectionNew data-name="HintQuestionsContainer">
      <CallUnderDescriptionBanner title="Напишите автору">
        <HintQuestions>
          {hintQuestions.map(({ buttonText }, index) => (
            <HintQuestion key={index} onClick={onClick} text={buttonText} />
          ))}
        </HintQuestions>
        <CallToAuthor phone={<PhonesContainer size="M" />} />
      </CallUnderDescriptionBanner>
    </CardSectionNew>
  );
};
